<button
  type="button"
  class="search-and-filter-button"
  mat-button
  aria-label="search / filter"
  [attr.aria-expanded]="opened"
  >
  @if (!opened) {
    <mat-icon>chevron_left</mat-icon>
    <span> Assignables by Page</span>
  } @else {
    <mat-icon>chevron_right</mat-icon>
  }
</button>
